var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", attrs: { type: "primary" } },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "search-item",
              {
                ref: "searchItem",
                attrs: {
                  "config-module": "3200",
                  reset: true,
                  "show-adv": true,
                  "show-simple": false,
                  "expand-adv": true,
                  "custom-search-items": _vm.customSearchItems,
                  "custom-sim-query-placeholder": _vm.$t(
                    "Message.QuickSearchBusinessNo"
                  )
                },
                on: {
                  "click-more": function(value) {
                    return (_vm.isAdvancedQuery = value)
                  },
                  advSearchItemCallBack: _vm.toAdvancedQuery,
                  advSearchItemResetCallBack: _vm.toAdvancedQuery
                }
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "operations" }, slot: "operations" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "4" },
                        on: { change: _vm.toQuery },
                        model: {
                          value: _vm.needRequire,
                          callback: function($$v) {
                            _vm.needRequire = $$v
                          },
                          expression: "needRequire"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "CargoMsg.Cargo_CostVirtualImplementationToConsolidationPlan"
                            )
                          )
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "24000522",
                    "grid-params": _vm.gridParams,
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "show-side-bar": false,
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    },
                    gridReady: function(params) {
                      return (_vm.gridApi = params.api)
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }